import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AppThemeProvider } from "@/context/ThemeContext";
import { ToastProvider } from "@/context/ToastContext";

function AppProviders({ children }) {
  return (
    <AppThemeProvider>
      <ToastProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {children}
        </LocalizationProvider>
      </ToastProvider>
    </AppThemeProvider>
  );
}

export { AppProviders as default };
